<template>
    <div class="home-page">
        <div class="app-container" :class="{ fullscreen: isFullscreen }">
            <div class="navi-bar">
                <div class="navi-bar-box">
                    <div class="top">
                        <div style="display: flex; justify-content: center;">
                            <img class="logo" :src="$store.state.userStore.userInfo.headImageThumb" alt="">
                        </div>
                        <div class="menu">
                            <div
                                class="menu-item"
                                v-for="item in menuItems"
                                :key="item.id"
                                :class="{ active: isMenuItemActive(item.id) }"
                                @click="activeChannel(item.id)"
                            >
                                <img
                                :src="isMenuItemActive(item.id) ? item.activeIcon : item.icon"
                                :style="{ width: item.width + 'px', height: item.height + 'px' }"
                                alt=""
                                />
                            </div>
                        </div>
                    </div>

                    <div class="botoom">
                        <div class="botoom-item" @click="activeChannel('settings')" title="设置" :class="{ active: isMenuItemActive('settings') }">
                            <img
                                :src="isMenuItemActive('settings') ? require('../assets/image/Settings_act.png') : require('../assets/image/Settings.png')"
                                style="width: 20px; height: 20px"
                                alt="设置"
                            />
                        </div>
                        <div class="botoom-item">
                            <el-popover placement="right" width="180" v-model="popoverVisible" trigger="click">
                                <div class="mine">
                                    <div class="mine-top">
                                        <div class="mine-top-l">
                                            <head-image slot="reference" :name="$store.state.userStore.userInfo.nickName" :size="44" :url="$store.state.userStore.userInfo.headImageThumb"></head-image>
                                            <span :class="$store.state.userStore.userInfo.status == 1?'mine-bot':'mine-bot-li'"></span>
                                        </div>
                                        <div class="mine-top-r">
                                            <span class="nickname">{{ $store.state.userStore.userInfo.nickName }}</span>
                                            <span :class="$store.state.userStore.roles.includes('customer_admin')?'mine-top-r-hui':'mine-top-r-text'">{{ $store.state.userStore.roles.includes('customer_admin')?'负责人':'普通成员' }}</span>
                                        </div>
                                    </div>
                                    <div class="mine-status" v-if="$store.state.cicadeStore.accounts.length > 0">
                                        <div style="color: #999999;">工作状态</div>
                                        <div>
                                            <el-switch @change="changeStatus" :value="$store.state.userStore.userInfo.status" :active-value="1" :inactive-value="0">
                                            </el-switch>
                                        </div>
                                    </div>
                                    <div class="mine-conter">
                                        <div class="mine-conter-item" @click="goPage('/home/setting/baseInfo')">
                                            <div class="mine-conter-item-title">
                                                <div class="icon"></div>
                                                <span>个人中心</span>
                                            </div>
                                        </div>
                                        <div class="mine-conter-item" @click="goPage('/home/setting/messenger')">
                                            <div class="mine-conter-item-title">
                                                <div class="icon2"></div>
                                                <span>切换语言</span>
                                            </div>
                                        </div>
                                        <div class="mine-conter-item" @click="onExit()">
                                            <div class="mine-conter-item-title">
                                                <div class="icon3"></div>
                                                <span>退出登录</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mine-bottom">
                                        <span>当前版本：</span>
                                        <span>V1.0.0</span>
                                    </div>
                                </div>
                                <head-image slot="reference" :name="$store.state.userStore.userInfo.nickName" :size="25" :url="$store.state.userStore.userInfo.headImageThumb">
                                    <span :class="$store.state.userStore.userInfo.status == 1?'mine-bot':'mine-bot-li'" class="mine-bot-icon"></span>
                                </head-image>
                            </el-popover>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-box">
                <router-view></router-view>
            </div>
            <user-info v-show="uiStore.userInfo.show" :pos="uiStore.userInfo.pos" :user="uiStore.userInfo.user" @close="$store.commit('closeUserInfoBox')"></user-info>
            <full-image :visible="uiStore.fullImage.show" :url="uiStore.fullImage.url" @close="$store.commit('closeFullImageBox')"></full-image>
            <rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
            <rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
            <full-video :visible="uiStore.fullVideo.show" :url="uiStore.fullVideo.url" @close="$store.commit('closeFullVideoBox')"></full-video>
            <sub-dialog v-if="showDialog" :visible="subdialogvis"></sub-dialog>
        </div>
    </div>
</template>

<script>
    import HeadImage from '../components/common/HeadImage.vue';
    import UserInfo from '../components/common/UserInfo.vue';
    import FullImage from '../components/common/FullImage.vue';
    import FullVideo from '../components/common/FullVideo.vue';
    import RtcPrivateVideo from '../components/rtc/RtcPrivateVideo.vue';
    import RtcPrivateAcceptor from '../components/rtc/RtcPrivateAcceptor.vue';
    import RtcGroupVideo from '../components/rtc/RtcGroupVideo.vue';

    export default {
        components: {
            HeadImage,
            UserInfo,
            FullImage,
            FullVideo,
            RtcPrivateVideo,
            RtcPrivateAcceptor,
            RtcGroupVideo
        },
        data() {
            return {
                showDialog: false,
                lastPlayAudioTime: new Date().getTime() - 1000,
                isFullscreen: true,
                popoverVisible: false,
                changeStatusTimer: null,
                originalTitle: document.title, // 保存原始标题
                titleScrollTimer: null, // 标题滚动定时器
                titleScrollText: '', // 滚动文字内容
                titleScrollIndex: 0, // 当前滚动位置
            };
        },
        methods: {
             changeStatus(status){
                if (this.changeStatusTimer) {
                    clearTimeout(this.changeStatusTimer);
                }
                this.changeStatusTimer = setTimeout(() => {
                    this.$http({
                        url: "/user/update",
                        method: "put",
                        data: { ...this.$store.state.userStore.userInfo, status },
                    }).then( async() => {
                        await this.$store.dispatch("loadUser");
                        await this.$store.commit("editAccountStatus",status);
                        this.$message.success("修改成功");
                    });
                }, 300);
            },
            goPage(path){
                this.$router.push({
                    path,
                })
                this.popoverVisible = false;
            },
            init() {
                this.$eventBus.$on('openPrivateVideo', (rctInfo) => {
                    // 进入单人视频通话
                    this.$refs.rtcPrivateVideo.open(rctInfo);
                });
                this.$eventBus.$on('openGroupVideo', (rctInfo) => {
                    // 进入多人视频通话
                    this.$refs.rtcGroupVideo.open(rctInfo);
                });

                this.$store
                    .dispatch('load')
                    .then(() => {
                        // ws初始化
                        this.$wsApi.connect(process.env.VUE_APP_WS_URL, sessionStorage.getItem('accessToken'));
                        this.$wsApi.onConnect(() => {
                            // ws(重)连成功后，增量补拉当前会话断连窗口期漏推的消息
                            this.$store.dispatch('syncCicadeChatHistory');
                        });
                        this.$wsApi.onMessage((cmd, msgInfo) => {
                            console.log('onMessage✅', cmd, msgInfo);
                            if (cmd == 2) {
                                this.$wsApi.close(3000);
                                this.$message.error('您已被强制下线');
                                location.href = '/';
                            } else if (cmd == 3) {
                                // 插入私聊消息
                                this.handlePrivateMessage(msgInfo);
                            } else if (cmd == 4) {
                                // 插入群聊消息
                                this.handleGroupMessage(msgInfo);
                            } else if (cmd == 5) {
                                // 处理系统消息
                                if (msgInfo.type == this.$enums.MESSAGE_TYPE.USER_BANNED){
                                    // 封禁
                                    this.handleSystemMessage(msgInfo);
                                } else if (msgInfo.type == this.$enums.MESSAGE_TYPE.USER_XIAXIAN){
                                    // 下线
                                    this.handleSystemxiaxian(msgInfo);
                                }
                            }
                            else if (cmd == 6) {
                                // 插入会话消息
                                // this.handleCicadeMessage(msgInfo);
                                this.$store.dispatch('insertCicadeMessage', msgInfo);
                            } else if (cmd == 7) {
                                // tiktok 评论
                                this.$store.dispatch('insertCicadeMessage', msgInfo);
                            } else if (cmd == 8) {
                                console.log('通知人工接管');
                                // 监听警报提示用户
                                // this.$store.dispatch('getGroupList');
                                this.$store.commit('setAddGroup', msgInfo);
                            } else if (cmd == 9) {
                                console.log('标记目标客户');
                                // 监听目前客户
                                this.$store.commit('addChatAttentionPoint', msgInfo.chatId);
                            } else if (cmd == 10) {
                                console.log('账号状态改变');
                                // 监听账号状态
                                this.$store.commit('setAccountStatus', msgInfo);
                            } else if (cmd == 11) {
                                console.log('分组用户改变');
                                // 监听群组变化
                                // this.$store.dispatch('getGroupList');
                                this.$store.commit('setAddGroup', msgInfo);
                            } else if (cmd == 16) {
                                // 插入会话消息
                                // this.handleCicadeMessage(msgInfo);
                                this.$store.dispatch('insertCicadeMessage', msgInfo);
                            } else if (cmd == 17) {
                                // 插入会话消息
                                // this.handleCicadeMessage(msgInfo);
                                this.$store.dispatch('insertCicadeMessage', msgInfo);
                                // 播放提示音：判断消息是否不是自己发送的，且不在当前活跃会话中
                                this.handleCicadeMessageTip(msgInfo);
                                // 修改标签页标题：如果不是自己发送的消息
                                this.handleTitleChange(msgInfo);
                                // 插入消息后更新分组排序
                                this.$store.dispatch('updateGroupList');
                            } else if (cmd == 18) {
                                // 插入会话消息
                                // this.handleCicadeMessage(msgInfo);
                                this.$store.dispatch('recall', msgInfo);
                            } else if (cmd == 19) {
                                // 更新会话消息
                                // 尝试多种可能的数据结构
                                let messageId = msgInfo.messageInfo.id;
                                let message = msgInfo.messageInfo;
                                this.$store.dispatch('updateCicadeMessage', {
                                    messageId,
                                    message
                                });
                            } else if (cmd == 20) {
                                // 会话入组/移动：只处理当前账号的，避免负责人多账号代看时把别的成员会话错加到当前列表
                                if (msgInfo.accountId == this.cicadeStore.activeAccount?.accountId) {
                                    this.$store.commit('setCustAddGroup', msgInfo);
                                }
                            } else if (cmd == 22) {
                                // 在线和离线
                                console.log('在线or离线', msgInfo);
                                if( msgInfo.accountId == this.cicadeStore.activeAccount.accountId){
                                    this.$store.commit('setChatStatus', msgInfo);
                                }
                            } else if (cmd == 23) {
                                // 在线和离线
                                console.log('已读', msgInfo);
                                console.log('已读', this.cicadeStore.activeChat.chatId);
                                if( msgInfo.accountId == this.cicadeStore.activeAccount.accountId && msgInfo.chatId == this.cicadeStore.activeChat.chatId){
                                    this.$store.commit('readedMessagestatus', msgInfo);
                                    console.log('===');
                                }
                            } else if (cmd == 24) {
                                // 会话设置变更（负责人/成员任一方修改，实时同步另一方的开关）
                                console.log('会话设置变更', msgInfo);
                                if (msgInfo.accountId == this.cicadeStore.activeAccount.accountId) {
                                    this.$store.commit('syncChatSettings', msgInfo);
                                }
                            }
                        });
                        this.$wsApi.onClose((e) => {
                            if (e.code != 3000) {
                                // 断线重连
                                this.$message.error('连接断开，正在尝试重新连接...');
                                this.$wsApi.reconnect(process.env.VUE_APP_WS_URL, sessionStorage.getItem('accessToken'));
                            }
                        });
                    })
                    .catch((e) => {
                        console.log('初始化失败', e);
                    });
            },
            pullPrivateOfflineMessage(minId) {
                this.$store.commit('loadingPrivateMsg', true);
                this.$http({
                    url: '/message/private/pullOfflineMessage?minId=' + minId,
                    method: 'GET'
                }).catch(() => {
                    this.$store.commit('loadingPrivateMsg', false);
                });
            },
            pullGroupOfflineMessage(minId) {
                this.$store.commit('loadingGroupMsg', true);
                this.$http({
                    url: '/message/group/pullOfflineMessage?minId=' + minId,
                    method: 'GET'
                }).catch(() => {
                    this.$store.commit('loadingGroupMsg', false);
                });
            },
            handlePrivateMessage(msg) {
                // 消息加载标志
                if (msg.type == this.$enums.MESSAGE_TYPE.LOADING) {
                    this.$store.commit('loadingPrivateMsg', JSON.parse(msg.content));
                    return;
                }
                // 消息已读处理，清空已读数量
                if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
                    this.$store.commit('resetUnreadCount', {
                        type: 'PRIVATE',
                        targetId: msg.recvId
                    });
                    return;
                }
                // 消息回执处理,改消息状态为已读
                if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
                    this.$store.commit('readedMessage', {
                        friendId: msg.sendId
                    });
                    return;
                }
                // 标记这条消息是不是自己发的
                msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
                // 单人webrtc 信令
                if (this.$msgType.isRtcPrivate(msg.type)) {
                    this.$refs.rtcPrivateVideo.onRTCMessage(msg);
                    return;
                }
                // 好友id
                let friendId = msg.selfSend ? msg.recvId : msg.sendId;
                this.loadFriendInfo(friendId).then((friend) => {
                    this.insertPrivateMessage(friend, msg);
                });
            },
            insertPrivateMessage(friend, msg) {
                let chatInfo = {
                    type: 'PRIVATE',
                    targetId: friend.id,
                    showName: friend.nickName,
                    headImage: friend.headImage
                };
                // 打开会话
                this.$store.commit('openChat', chatInfo);
                // 插入消息
                this.$store.commit('insertMessage', [msg, chatInfo]);
                // 播放提示音
                if (!msg.selfSend && this.$msgType.isNormal(msg.type) && msg.status != this.$enums.MESSAGE_STATUS.READED) {
                    this.playAudioTip();
                }
            },
            handleGroupMessage(msg) {
                // 消息加载标志
                if (msg.type == this.$enums.MESSAGE_TYPE.LOADING) {
                    this.$store.commit('loadingGroupMsg', JSON.parse(msg.content));
                    return;
                }
                // 消息已读处理
                if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
                    // 我已读对方的消息，清空已读数量
                    let chatInfo = {
                        type: 'GROUP',
                        targetId: msg.groupId
                    };
                    this.$store.commit('resetUnreadCount', chatInfo);
                    return;
                }
                // 消息回执处理
                if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
                    // 更新消息已读人数
                    let msgInfo = {
                        id: msg.id,
                        groupId: msg.groupId,
                        readedCount: msg.readedCount,
                        receiptOk: msg.receiptOk
                    };
                    this.$store.commit('updateMessage', msgInfo);
                    return;
                }
                // 标记这条消息是不是自己发的
                msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
                // 群视频信令
                if (this.$msgType.isRtcGroup(msg.type)) {
                    this.$nextTick(() => {
                        this.$refs.rtcGroupVideo.onRTCMessage(msg);
                    });
                    return;
                }
                this.loadGroupInfo(msg.groupId).then((group) => {
                    // 插入群聊消息
                    this.insertGroupMessage(group, msg);
                });
            },
            insertGroupMessage(group, msg) {
                let chatInfo = {
                    type: 'GROUP',
                    targetId: group.id,
                    showName: group.showGroupName,
                    headImage: group.headImageThumb
                };
                // 打开会话
                this.$store.commit('openChat', chatInfo);
                // 插入消息
                this.$store.commit('insertMessage', [msg, chatInfo]);
                // 播放提示音
                if (!msg.selfSend && msg.type <= this.$enums.MESSAGE_TYPE.VIDEO && msg.status != this.$enums.MESSAGE_STATUS.READED) {
                    this.playAudioTip();
                }
            },
            handleSystemMessage(msg) {
                // 用户被封禁

                if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
                    this.$message.error('您的账号已被管理员封禁,原因:' + msg.content);
                    this.$wsApi.close(3000);
                    sessionStorage.removeItem('activeChat');
                    sessionStorage.removeItem('accessToken');
                    location.href = '/';
                    return;
                }
            },

            handleSystemxiaxian(msg) {
                // 用户下线
                if (msg.type == this.$enums.MESSAGE_TYPE.USER_XIAXIAN) {
                    this.$message.error('您的账号已被管理员踢下线');
                    this.$wsApi.close(3000);
                    sessionStorage.removeItem('activeChat');
                    sessionStorage.removeItem('accessToken');
                    location.href = '/';
                    return;
                }
            },
            onExit() {
                this.popoverVisible = false;
                this.$confirm('你确定要退出登录吗?, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wsApi.close(3000);
                    sessionStorage.removeItem('activeChat');
                    sessionStorage.removeItem('accessToken');
                    location.href = '/';
                })
            },
            playAudioTip() {
                // 离线消息不播放铃声
                // if (this.$store.getters.isLoading()) {
                //     return;
                // }

                if (this.$root.$playAudioTip) {
                    this.$root.$playAudioTip();
                } else {
                    // 如果根实例方法不存在，使用 eventBus
                    this.$eventBus.$emit('playAudioTip');
                }
            },
            // 判断消息是否是自己发送的
            isSelfSendMessage(msgInfo) {
                const cicadeStore = this.$store.state.cicadeStore;
                const activeAccount = cicadeStore.activeAccount;
                
                if (!activeAccount) {
                    return false;
                }
                
                // 根据不同平台判断是否是自己发送的消息
                if (msgInfo.platform === 'customer') {
                    // customer平台：senderId != chatId 表示是自己发送的
                    return msgInfo.senderId != msgInfo.chatId;
                } else if (msgInfo.platform === 'facebook_api') {
                    // facebook_api平台：senderId != chatId 表示是自己发送的
                    const chatId = msgInfo.chatIdStr ? msgInfo.chatIdStr : msgInfo.chatId;
                    return msgInfo.senderId != chatId;
                } else {
                    // 其他平台：senderId == activeAccount[tgUserId] 表示是自己发送的
                    const sendIdKey = cicadeStore.sendIdKey || 'tgUserId';
                    return msgInfo.senderId == activeAccount[sendIdKey];
                }
            },
            handleCicadeMessageTip(msgInfo) {
                // 判断消息是否不是自己发送的
                const isSelfSend = this.isSelfSendMessage(msgInfo);
                
                if (!isSelfSend) {
                    const normalTypes = ['text', 'image', 'video', 'audio', 'file'];
                    if (!msgInfo.type || normalTypes.includes(msgInfo.type)) {
                        const messageChatId = msgInfo.chatIdStr ? msgInfo.chatIdStr : msgInfo.chatId;
                        if (messageChatId) {
                            this.playAudioTip();
                        }
                    }
                }
            },
            // 处理标签页标题变化
            handleTitleChange(msgInfo) {
                // 如果不是自己发送的消息，且页面不可见时，修改标题并开始滚动
                if (!this.isSelfSendMessage(msgInfo) && document.hidden) {
                    const scrollText = `${msgInfo.title}发来新消息，请查收! `;
                    this.startTitleScroll(scrollText);
                }
            },
            // 开始标题滚动
            startTitleScroll(text) {
                // 先清除之前的滚动
                this.stopTitleScroll();
                
                this.titleScrollText = text;
                this.titleScrollIndex = 0;
                
                // 启动滚动定时器，每100ms更新一次
                this.titleScrollTimer = setInterval(() => {
                    // 将文字循环滚动显示
                    const displayText = this.titleScrollText.substring(this.titleScrollIndex) + 
                                       this.titleScrollText.substring(0, this.titleScrollIndex);
                    document.title = displayText;
                    this.titleScrollIndex = (this.titleScrollIndex + 1) % this.titleScrollText.length;
                }, 100);
            },
            // 停止标题滚动
            stopTitleScroll() {
                if (this.titleScrollTimer) {
                    clearInterval(this.titleScrollTimer);
                    this.titleScrollTimer = null;
                }
                this.titleScrollText = '';
                this.titleScrollIndex = 0;
            },
            // 恢复原始标题
            restoreTitle() {
                // 停止滚动
                this.stopTitleScroll();
                // 恢复原始标题
                if (document.title !== this.originalTitle) {
                    document.title = this.originalTitle;
                }
            },
            // 处理页面可见性变化
            handleVisibilityChange() {
                if (!document.hidden) {
                    // 页面可见时恢复原始标题
                    this.restoreTitle();
                }
            },
            loadFriendInfo(id) {
                return new Promise((resolve, reject) => {
                    let friend = this.$store.state.friendStore.friends.find((f) => f.id == id);
                    if (friend) {
                        resolve(friend);
                    } else {
                        this.$http({
                            url: `/friend/find/${id}`,
                            method: 'get'
                        }).then((friend) => {
                            this.$store.commit('addFriend', friend);
                            resolve(friend);
                        });
                    }
                });
            },
            loadGroupInfo(id) {
                return new Promise((resolve, reject) => {
                    let group = this.$store.state.groupStore.groups.find((g) => g.id == id);
                    if (group) {
                        resolve(group);
                    } else {
                        this.$http({
                            url: `/group/find/${id}`,
                            method: 'get'
                        }).then((group) => {
                            resolve(group);
                            this.$store.commit('addGroup', group);
                        });
                    }
                });
            },
            activeChannel(id) {
                // 如果点击的是 settings，跳转到设置页面
                if (id === 'settings') {
                    // 清空当前激活的频道，这样从 settings 返回时可以重新点击
                    this.$store.commit('activeChannel', {
                        context: this.$store,
                        channelId: null
                    });
                    this.$router.push({
                        path: '/home/setting/'
                    });
                    return;
                }
                
                // 只有在聊天页面且点击的是当前激活的频道时才阻止
                const isInChatPage = this.$route.path === '/home/chat';
                const isSameChannel = this.$store.state.cicadeStore.activeChannel?.id === id;
                if(isInChatPage && isSameChannel) return;
                
                if(this.$route.path != '/home/chat'){
                    this.$router.push({
                        path: '/home/chat'
                    })
                }
                this.$store.commit('activeChannel', {
                    context: this.$store,
                    channelId: id
                });
            },
            isMenuItemActive(itemId) {
                // 如果当前在设置页面
                const isInSettingPage = this.$route.path.startsWith('/home/setting');
                
                // 如果是 settings 按钮，判断当前路由是否以 /home/setting 开头
                if (itemId === 'settings') {
                    return isInSettingPage;
                }
                
                // 如果在设置页面，其他菜单项都不激活
                if (isInSettingPage) {
                    return false;
                }
                
                // 其他菜单项，判断是否是当前激活的 channel
                return this.cicadeStore.activeChannel?.id === itemId;
            }
        },
        computed: {
            subdialogvis() {
                return this.$store.state.userStore.packageInfo.isMember;
            },
            status(){
                return this.$store.state.userStore.userInfo.status || 0;
            },
            uiStore() {
                return this.$store.state.uiStore;
            },
            cicadeStore() {
                return this.$store.state.cicadeStore;
            },
            channelList() {
                return this.$store.state.cicadeStore.channels.filter(item=>{
                    return item.status !== 0
                })
            },
            unreadCount() {
                let unreadCount = 0;
                let chats = this.$store.state.chatStore.chats;
                chats.forEach((chat) => {
                    if (!chat.delete) {
                        unreadCount += chat.unreadCount;
                    }
                });
                return unreadCount;
            },
            menuItems() {
                return this.channelList.map(channel => ({
                    id: channel.id,
                    icon: require(`../assets/image/${channel.channelName}.png`),
                    activeIcon: require(`../assets/image/${channel.channelName}_act.png`),
                    width: 25,
                    height: 25
                }));
            }
        },
        watch: {
            unreadCount: {
                handler(newCount, oldCount) {
                    let tip = newCount > 0 ? `${newCount}条未读` : '';
                    this.$elm.setTitleTip(tip);
                },
                immediate: true
            },
            $route(to, from) {
                this.showDialog = to.path === '/home/chat';
            },
        },
        mounted() {
            if (Notification.permission === 'granted') {
                console.log("权限已授予，您可以开始发送通知");
            } else if (Notification.permission === 'default') {
                Notification.requestPermission().then(permission => {
                    if (permission === 'granted') {
                    console.log("通知权限已授予");
                    }
                });
            }
            this.showDialog = this.$route.path === '/home/chat';
            this.init();
            
            // 监听页面可见性变化，恢复标题
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
        },
        beforeDestroy() {
            this.$wsApi.close();
            // 停止标题滚动
            this.stopTitleScroll();
            // 移除页面可见性监听
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        }
    };
</script>

<style scoped lang="scss">
    .home-page {
        height: 100vh;
        width: 100vw;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        overflow: hidden;
        border-right: 1px solid red;
        // background: var(--im-color-primary-light-9);
        // background-image: url('../assets/image/background.jpg');

        .app-container {
            width: 62vw;
            height: 80vh;
            display: flex;
            min-height: 600px;
            min-width: 970px;
            position: absolute;
            border-radius: 4px;
            overflow: hidden;
            box-shadow: var(--im-box-shadow-dark);
            transition: 0.2s;

            &.fullscreen {
                transition: 0.2s;
                width: 100vw;
                height: 100vh;
            }
        }

        .navi-bar {
            --icon-font-size: 22px;
            --width: 52px;
            width: var(--width);
            // background: var(--im-color-primary-light-1);
            padding-top: 20px;
            // border-right: 1px solid #f3f3f3;
            background: #ebebeb;
            .navi-bar-box {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .botoom {
                    margin-bottom: 30px;
                }
            }

            .user-head-image {
                display: flex;
                justify-content: center;
            }

            .menu {
                // height: 260px;
                margin-top: 12px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-content: center;

                .link {
                    text-decoration: none;
                }

                .router-link-active .menu-item {
                    color: #fff;
                    background: var(--im-color-primary-light-2);
                }

                .link:not(.router-link-active) .menu-item:hover {
                    color: var(--im-color-primary-light-7);
                }

                .menu-item {
                    position: relative;
                    color: var(--im-color-primary-light-4);
                    width: var(--width);
                    height: 52px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;

                    &.active {
                        color: #fff;
                        font-weight: 600;
                        background: #fff;
                    }

                    &.active::before {
                        content: '';
                        width: 3px;
                        height: 100%;
                        position: absolute;
                        left: 0;
                        background: #1677ff;
                    }

                    .icon {
                        font-size: var(--icon-font-size);
                    }

                    .unread-text {
                        position: absolute;
                        background-color: var(--im-color-danger);
                        left: 28px;
                        top: 8px;
                        color: white;
                        border-radius: 30px;
                        padding: 0 5px;
                        font-size: var(--im-font-size-smaller);
                        text-align: center;
                        white-space: nowrap;
                        border: 1px solid #f1e5e5;
                    }
                }
            }

            .botoom-item {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 50px;
                width: 100%;
                cursor: pointer;
                color: var(--im-color-primary-light-4);
                font-size: var(--icon-font-size);

                .icon {
                    font-size: var(--icon-font-size);
                }

                &.active {
                    color: #fff;
                    font-weight: 600;
                    background: #fff;
                }

                &.active::before {
                    content: '';
                    width: 2px;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    background: #1677ff;
                }

                &:hover {
                    font-weight: 600;
                    color: var(--im-color-primary-light-7);
                }
            }
        }

        .content-box {
            flex: 1;
            padding: 0;
            background-color: #fff;
            text-align: center;
        }
    }

    .mine{
        display: flex;
        flex-direction: column;
        .mine-top{
            display: flex;
            height: 50px;
            padding: 0 0 12px;
            .mine-top-l{
                position: relative;
                margin-right: 10px;
            }
            .mine-top-r{
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .nickname{
                    width: 100px;
                    font-size: 15px;
                    font-weight: 500;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .mine-top-r-text{
                    padding: 2px 4px;
                    font-size: 12px;
                    color: #F89733;
                    background: #fff4ea;
                    border-radius: 5px;
                    width: fit-content;
                }
                .mine-top-r-hui{
                    padding: 2px 4px;
                    font-size: 12px;
                    color: #1677FF;
                    background: #e3effe;
                    border-radius: 5px;
                    width: fit-content;
                }
            }
        }
        .mine-status{
            padding: 10px 15px 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: default;
            border-top: 1px solid #F6F6F7;
        }
        .mine-conter{
            display: flex;
            flex-direction: column;
            border-bottom: 1px solid #F6F6F7;
            padding-bottom: 10px;
            .mine-conter-item{
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 15px;
                .mine-conter-item-title{
                    display: flex;
                    align-items: center;
                }
                .icon{
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    margin-right: 10px;
                    background-size: cover;
                    background-image: url('../assets/image/mine.png');
                }
                .icon2{
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    margin-right: 10px;
                    background-size: cover;
                    background-image: url('../assets/image/language.png');
                }
                .icon3{
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    margin-right: 10px;
                    background-size: cover;
                    background-image: url('../assets/image/logout.png');
                }
            }
            .mine-conter-item:hover{
                background: #f7f9ff;
                border-radius: 50px;
                color: #1677ff;
                cursor: pointer;
                .icon{
                    width: 16px;
                    height: 16px;
                    background-size: cover;
                    background-image: url('../assets/image/mine_act.png');
                }
                .icon2{
                    width: 16px;
                    height: 16px;
                    background-size: cover;
                    background-image: url('../assets/image/language_act.png');
                }
                .icon3{
                    width: 16px;
                    height: 16px;
                    background-size: cover;
                    background-image: url('../assets/image/logout_act.png');
                }
            }
        }
        .mine-bottom{
            cursor: default;
            padding: 10px 15px 0;
            font-weight: 400;
            font-size: 13px;
            color: #999999;
        }
    }
    .logo{
        width: 40px;
        height: 40px;
        border-radius: 5px;
    }
    .mine-bot{
        position: absolute;
        bottom: 5px;
        right: 0px;
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #00c853;
        border: 2px solid #fff;
    }
    .mine-bot-li{
        position: absolute;
        bottom: 5px;
        right: 0px;
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #c3c3c3;
        border: 2px solid #fff;
    }
    .mine-bot-icon{
        width: 5px;
        height: 5px;
        bottom: -2px;
        right: -2px;
    }
</style>
